<!-- Main navigation -->
<header>
  <!--Navbar-->
  <mdb-navbar [SideClass]="'navbar navbar-expand-lg navbar-dark pb-0 pt-0 fixed-top scrolling-navbar' + ( logged ? '' : ' navbar-intro' )">

    <mdb-navbar-brand>
      <a class="logo navbar-brand waves-light text-nowrap text-theme" mdbWavesEffect href="#"><mdb-icon fas icon="home"></mdb-icon></a>
      

      

    </mdb-navbar-brand>

    <mdb-navbar-brand>
      <a class="navbar-brand d-flex text-theme precio-total-nav">

        <h4 class="mb-0 mr-2" *ngIf="showTotalWallet">{{cartera?.nombre}}</h4>
        <ng-template appPriceTotalWallet></ng-template>

      </a>
    </mdb-navbar-brand>


    <links>
      <app-navbar [user]="user" [logged]="logged" class="ml-auto"></app-navbar>
    </links>

  </mdb-navbar>

  <!-- Full Page Intro -->
  <div class="view" *ngIf="!logged; else main_content"
       style="background-image: url('assets/fondo1_gestor_visor.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;">
    <!-- Mask & flexbox options-->
    <div class="mask rgba-gradient d-md-flex justify-content-center align-items-center">
      <!-- Content -->
      <div class="container">
        <!--Grid row-->
        <div class="row mt-5">

          <!--Grid column-->
          <div class="col-md-6 mb-5 mt-md-0 mt-5 white-text text-center text-md-left">
            <h1 class="h1-responsive font-weight-bold wow fadeInLeft" data-wow-delay="0.3s">Sign up right now! </h1>
            <hr class="hr-light wow fadeInLeft" data-wow-delay="0.3s">
            <h6 class="mb-3 wow fadeInLeft" data-wow-delay="0.3s">Lorem ipsum dolor sit amet, consectetur adipisicing
              elit. Rem repellendus quasi fuga
              nesciunt dolorum nulla magnam veniam sapiente, fugiat! Commodi sequi non animi ea
              dolor molestiae, quisquam iste, maiores. Nulla.</h6>
            <a mdbBtn color="white" outline="true" mdbWavesEffect class="wow fadeInLeft" data-wow-delay="0.3s">Learn
              more</a>
          </div>
          <!--Grid column-->
          <!--Grid column-->
          <div class="col-md-6 col-xl-5 mb-4 position-relative" [style]="'opacity:' + (ready ? '1' : '0')">

            <app-register [formType]="formType" (onGoToLogin)="toggleForm()"></app-register>

            <app-login [formType]="formType" (onGoToRegister)="toggleForm()" (onLoginSuccess)="loginSuccess($event)"></app-login>

          </div>
          <!--Grid column-->
        </div>
        <!--Grid row-->
      </div>
      <!-- Content -->
    </div>
    <!-- Mask & flexbox options-->
  </div>
  <!-- Full Page Intro -->

</header>
<!-- Main navigation -->

<ng-template #main_content>
  <div class="view" *ngIf="logged">
    <!-- Content -->
    <div class="container-fluid" style="padding-top: 4rem">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="requesting">
  <mdb-badge success="true" class="my-auto px-2 py-1 requesting">Sync</mdb-badge>
</ng-container>

<div class="loader-mask mask pattern-1" *ngIf="loading"></div>

<div class="spinning-preloader-container" [class.complete]="!loading">

  <div class="preloader-wrapper big active">

    <div class="spinner-layer spinner-blue">
      <div class="circle-clipper left">
        <div class="circle"> </div>
      </div> <div class="gap-patch">
      <div class="circle"> </div>
    </div>
    </div>

    <div class="spinner-layer spinner-red">
      <div class="circle-clipper left">
        <div class="circle"> </div>
      </div> <div class="gap-patch">
      <div class="circle"> </div>
    </div>
    </div>

    <div class="spinner-layer spinner-yellow">
      <div class="circle-clipper left">
        <div class="circle"> </div>
      </div> <div class="gap-patch">
      <div class="circle"> </div>
    </div>
    </div>

    <div class="spinner-layer spinner-green">
      <div class="circle-clipper left">
        <div class="circle"> </div>
      </div> <div class="gap-patch">
      <div class="circle"> </div>
    </div>
    </div>

  </div>

</div>
